import Navbar from './home/components/Navbar';
import Footer from './home/components/Footer';
import RegisterLink from '../components/RegisterLink';
import { useLanguage } from '../contexts/LanguageContext';
import { FEATURED_BONUSES, FEATURED_BONUS_SUMMARY_BM, FEATURED_BONUS_SUMMARY_EN } from '../constants/bonuses';
import { usePageSeo } from '../hooks/usePageSeo';
import { LinkedText } from '../components/LinkedText';
import gameBannerGif from '../assets/game-banner.gif';

const seoSections = [
  {
    id: 'bonus-overview',
    en_title: 'MrCuci Bonus Overview: 4 Active Promotions for Malaysian Players in 2026',
    bm_title: 'Gambaran Keseluruhan Bonus MrCuci: 4 Promosi Aktif untuk Pemain Malaysia 2026',
    paragraphs: [
      {
        en: `MrCuci currently runs four headline promotions designed for Malaysian players at every stage — ${FEATURED_BONUS_SUMMARY_EN}. Each offer is governed by clear terms in the bonus centre, and all payouts are credited directly in Ringgit.`,
        bm: `MrCuci kini menjalankan empat promosi utama yang direka untuk pemain Malaysia di setiap peringkat — ${FEATURED_BONUS_SUMMARY_BM}. Setiap tawaran dikawal oleh terma yang jelas di pusat bonus, dan semua bayaran dikreditkan terus dalam Ringgit.`,
      },
      {
        en: 'Whether you are registering for the first time, making your opening deposit, topping up with RM200, or competing in the monthly deposit ranking, there is a structured promotion ready to boost your balance with transparent rules and fast processing.',
        bm: 'Sama ada anda mendaftar buat kali pertama, membuat deposit pembukaan, topup RM200, atau bersaing dalam kedudukan deposit bulanan, terdapat promosi berstruktur yang sedia meningkatkan baki anda dengan peraturan telus dan pemprosesan pantas.',
      },
    ],
  },
  {
    id: 'new-member-register-rm88',
    en_title: 'New Member Register Free RM88: No-Deposit Credit for New Accounts',
    bm_title: 'Ahli Baharu Daftar Percuma RM88: Kredit Tanpa Deposit untuk Akaun Baharu',
    paragraphs: [
      {
        en: 'New Member Register Free RM88 gives first-time registrants RM88 bonus credit with no deposit required. The offer is limited to one claim per MrCuci member ID, making it one of the strongest no-deposit entry incentives in the Malaysian market.',
        bm: 'Ahli Baharu Daftar Percuma RM88 memberi pemain baharu kredit bonus RM88 tanpa deposit diperlukan. Tawaran ini terhad kepada satu tuntutan setiap ID ahli MrCuci, menjadikannya salah satu insentif kemasukan tanpa deposit terkuat dalam pasaran Malaysia.',
      },
      {
        en: 'Eligible play is focused on Semaut Event Game slots. Free game buy/save, angpao save, live and table games, and wild save features are excluded. Register, verify your account, and the credit is issued directly after registration.',
        bm: 'Permainan layak difokuskan pada slot Semaut Event Game. Beli/simpan permainan percuma, simpan angpau, permainan langsung dan meja, serta simpan wild tidak termasuk. Daftar, sahkan akaun anda, dan kredit dikeluarkan terus selepas pendaftaran.',
      },
    ],
  },
  {
    id: 'monthly-competition-deposit-ranking',
    en_title: 'Monthly Competition Deposit Ranking: Top Prize Up to RM1,088',
    bm_title: 'Pertandingan Bulanan Kedudukan Deposit: Hadiah Utama Sehingga RM1,088',
    paragraphs: [
      {
        en: 'The Monthly Competition Deposit Ranking runs from the 1st to the last day of every month. Rankings are calculated based on total deposits only — the more you deposit during the month, the higher your position climbs.',
        bm: 'Pertandingan Bulanan Kedudukan Deposit berlangsung dari 1hb hingga hari terakhir setiap bulan. Kedudukan dikira berdasarkan jumlah deposit sahaja — semakin banyak anda deposit sepanjang bulan, semakin tinggi kedudukan anda.',
      },
      {
        en: 'Rewards are settled and distributed after each competition ends. The top rank can win up to RM1,088 cash, with additional cash prizes for ranks #2 through #10. Winners should contact Live Chat to proceed with their reward claim.',
        bm: 'Ganjaran diselesaikan dan diedarkan selepas setiap pertandingan tamat. Kedudukan #1 boleh memenangi sehingga RM1,088 tunai, dengan hadiah tunai tambahan untuk kedudukan #2 hingga #10. Pemenang perlu hubungi Live Chat untuk meneruskan tuntutan ganjaran.',
      },
    ],
  },
  {
    id: 'welcome-and-deposit-bonuses',
    en_title: 'Welcome Bonus 50% and Deposit RM200 Free RM200',
    bm_title: 'Bonus Selamat Datang 50% dan Deposit RM200 Percuma RM200',
    paragraphs: [
      {
        en: 'The Welcome Bonus 50% applies to your first deposit from RM1, with one claim per member ID. It is valid on all slots except excluded providers such as Jili, Lucky365, MicroGaming, RedTiger, Boongo, and In Out.',
        bm: 'Bonus Selamat Datang 50% terpakai pada deposit pertama anda dari RM1, dengan satu tuntutan setiap ID ahli. Ia sah untuk semua slot kecuali pembekal terkecuali seperti Jili, Lucky365, MicroGaming, RedTiger, Boongo, dan In Out.',
      },
      {
        en: 'Deposit RM200 Free RM200 rewards a RM200 deposit with RM200 free bonus. Claim when your balance is below RM1, once per day, with ×10 turnover, max withdraw RM200, and no rollover. Fast deposit within 3 minutes via local bank or e-wallet.',
        bm: 'Deposit RM200 Percuma RM200 memberi ganjaran deposit RM200 dengan bonus percuma RM200. Tuntut apabila baki bawah RM1, sekali sehari, dengan turnover ×10, max cuci RM200, dan tiada rollover. Deposit pantas dalam 3 minit melalui bank tempatan atau e-dompet.',
      },
    ],
  },
  {
    id: 'how-to-claim',
    en_title: 'How to Claim MrCuci Bonuses: Step-by-Step Guide for Malaysian Players',
    bm_title: 'Cara Menuntut Bonus MrCuci: Panduan Langkah demi Langkah untuk Pemain Malaysia',
    paragraphs: [
      {
        en: "Claiming bonuses at MrCuci follows a consistent process across all promotion types. After logging into your account, navigate to the Bonus Centre where all active promotions are listed with their current terms. Select the promotion you intend to claim, confirm the deposit amount required to activate it, and complete the deposit using any supported payment channel.",
        bm: 'Menuntut bonus di MrCuci mengikuti proses yang konsisten merentas semua jenis promosi. Selepas log masuk ke akaun anda, navigasi ke Pusat Bonus di mana semua promosi aktif disenaraikan bersama terma semasa mereka. Pilih promosi yang ingin anda tuntut, sahkan jumlah deposit yang diperlukan, dan lengkapkan deposit menggunakan saluran pembayaran yang disokong.',
      },
      {
        en: 'For no-deposit promotions like New Member Register Free RM88, the credit is issued directly after account registration. For Monthly Competition Deposit Ranking prizes, contact Live Chat after the competition ends. If you encounter any issue with a bonus credit, MrCuci support is available 24/7 in English and Bahasa Malaysia.',
        bm: 'Untuk promosi tanpa deposit seperti Ahli Baharu Daftar Percuma RM88, kredit dikeluarkan terus selepas pendaftaran akaun. Untuk hadiah Pertandingan Bulanan Kedudukan Deposit, hubungi Live Chat selepas pertandingan tamat. Jika anda menghadapi sebarang masalah dengan kredit bonus, sokongan MrCuci tersedia 24/7 dalam Bahasa Inggeris dan Bahasa Malaysia.',
      },
    ],
  },
];

export default function BonusPage() {
  const { lang, t } = useLanguage();
  const title = t(
    'MrCuci Bonus Malaysia | Free RM88, 50% Welcome & RM1088 Ranking',
    'Bonus MrCuci Malaysia | RM88 Percuma, Selamat Datang 50% & Ranking RM1088'
  );
  const description = t(
    'View current MrCuci Malaysia bonuses: register free RM88, Welcome Bonus 50%, Deposit RM200 Free RM200 and Monthly Deposit Ranking prize up to RM1088.',
    'Lihat bonus semasa MrCuci Malaysia: daftar percuma RM88, Bonus Selamat Datang 50%, Deposit RM200 Percuma RM200 dan hadiah Kedudukan Deposit Bulanan sehingga RM1088.'
  );

  usePageSeo({
    title,
    description,
    path: '/bonus/',
    language: lang === 'bm' ? 'ms-MY' : 'en-MY',
    keywords: [
      'MrCuci bonus',
      'MrCuci Malaysia bonus',
      'online casino bonus Malaysia',
      'casino free credit Malaysia',
      'register free RM88',
      'welcome bonus 50 Malaysia',
      'deposit RM200 free RM200',
      'monthly deposit ranking RM1088',
      'no deposit bonus Malaysia',
      'bonus kasino Malaysia',
      'promosi kasino dalam talian Malaysia',
    ],
    schema: {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      '@id': 'https://www.mrcuci.me/bonus/#webpage',
      url: 'https://www.mrcuci.me/bonus/',
      name: title,
      description,
      inLanguage: lang === 'bm' ? 'ms-MY' : 'en-MY',
      isPartOf: { '@id': 'https://www.mrcuci.me/#website' },
      mainEntity: {
        '@type': 'ItemList',
        name: t('Current MrCuci Malaysia Bonuses', 'Bonus Semasa MrCuci Malaysia'),
        numberOfItems: FEATURED_BONUSES.length,
        itemListElement: FEATURED_BONUSES.map((bonus, index) => ({
          '@type': 'ListItem',
          position: index + 1,
          item: {
            '@type': 'Offer',
            name: t(bonus.en_title, bonus.bm_title),
            description: t(bonus.en_desc, bonus.bm_desc),
            url: `https://www.mrcuci.me/bonus/#${bonus.id}`,
            priceCurrency: 'MYR',
          },
        })),
      },
    },
  });

  return (
    <div className="min-h-screen bg-[#080000] font-sans">
      <Navbar />

      <main className="pt-20">
        {/* Hero */}
        <section
          className="py-12 md:py-16 border-b border-[#d4a017]/10"
          style={{ background: 'linear-gradient(135deg, #0d0000 0%, #1a0303 55%, #0d0000 100%)' }}
        >
          <div className="max-w-7xl mx-auto px-4 md:px-6 grid lg:grid-cols-2 gap-10 items-center">
            <div>
              <p className="text-[#d4a017] text-xs md:text-sm font-semibold tracking-widest uppercase mb-4">
                {t('MrCuci Bonuses & Promotions', 'Bonus & Promosi MrCuci')}
              </p>
              <h1 className="text-3xl md:text-5xl font-black text-white leading-tight mb-4">
                <LinkedText>{t(
                  'Malaysia Online Casino Bonuses at MrCuci',
                  'Bonus Kasino Dalam Talian Malaysia di MrCuci'
                )}</LinkedText>
              </h1>
              <p className="text-gray-300 text-sm md:text-base leading-relaxed mb-6">
                <LinkedText>{t(
                  `Explore all active bonus promotions at MrCuci — ${FEATURED_BONUS_SUMMARY_EN}. Every offer is designed for Malaysian players with clear terms and fast Ringgit payouts.`,
                  `Terokai semua promosi bonus aktif di MrCuci — ${FEATURED_BONUS_SUMMARY_BM}. Setiap tawaran direka untuk pemain Malaysia dengan terma yang jelas dan bayaran Ringgit yang pantas.`
                )}</LinkedText>
              </p>
              <div className="flex flex-wrap gap-3">
                <RegisterLink
                  source="bonus_page_claim_now"
                  label={t('Claim Bonus Now', 'Tuntut Bonus Sekarang')}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="inline-flex items-center gap-2 font-bold px-6 py-3 rounded-lg text-sm"
                  style={{ background: 'linear-gradient(135deg, #cc1100, #ff2200)', color: 'white' }}
                >
                  <span>{t('Claim Bonus Now', 'Tuntut Bonus Sekarang')}</span>
                  <i className="ri-external-link-line" />
                </RegisterLink>
                <RegisterLink
                  source="bonus_page_register_free"
                  label={t('Register Free', 'Daftar Percuma')}
                  className="inline-flex items-center gap-2 font-bold px-6 py-3 rounded-lg text-sm border border-[#d4a017]/40 text-[#d4a017] hover:border-[#d4a017] transition-colors"
                >
                  <span>{t('Register Free', 'Daftar Percuma')}</span>
                  <i className="ri-user-add-line" />
                </RegisterLink>
              </div>
            </div>

            {/* Stats sidebar */}
            <div className="grid grid-cols-2 gap-3 lg:gap-4">
              {[
                { num: '4', label_en: 'Active Promotions', label_bm: 'Promosi Aktif' },
                { num: '50%', label_en: 'Welcome Bonus', label_bm: 'Bonus Selamat Datang' },
                { num: 'RM88', label_en: 'Free on Register', label_bm: 'Percuma Semasa Daftar' },
                { num: 'RM1088', label_en: 'Top Monthly Prize', label_bm: 'Hadiah Bulanan Teratas' },
              ].map((stat) => (
                <div
                  key={stat.num}
                  className="rounded-xl p-4 md:p-5 border border-[#d4a017]/15 text-center"
                  style={{ background: 'linear-gradient(135deg, #180303, #200404)' }}
                >
                  <p
                    className="text-2xl md:text-3xl font-black mb-1 text-transparent bg-clip-text"
                    style={{ backgroundImage: 'linear-gradient(135deg, #d4a017, #f5c518)' }}
                  >
                    {stat.num}
                  </p>
                  <p className="text-gray-400 text-xs">{t(stat.label_en, stat.label_bm)}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Bonus cards grid */}
        <section className="py-12 md:py-16">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="mb-8">
              <h2 className="text-2xl md:text-3xl font-black text-white mb-2">
                {t('All Active Bonus Promotions', 'Semua Promosi Bonus Aktif')}
              </h2>
              <p className="text-gray-400 text-sm">
                {t(
                  'Click any bonus card to open the MrCuci lobby and start claiming.',
                  'Klik mana-mana kad bonus untuk buka lobi MrCuci dan mula tuntut.'
                )}
              </p>
            </div>

            <div className="flex flex-wrap" style={{ margin: '-5px' }}>
              {FEATURED_BONUSES.map((bonus) => {
                const ineligible = false;
                return (
                  <div
                    id={bonus.id}
                    key={bonus.id}
                    style={{ padding: '5px', width: '50%', maxWidth: 160 }}
                    className="scroll-mt-24 sm:w-1/3 md:w-1/4 lg:w-1/5"
                  >
                    <RegisterLink
                      source={`bonus_page_card_${bonus.id}`}
                      label={t(bonus.en_title, bonus.bm_title)}
                      target={ineligible ? undefined : '_blank'}
                      rel="noopener noreferrer nofollow"
                      className={`block relative overflow-hidden select-none${ineligible ? ' cursor-default' : ' cursor-pointer'}`}
                      style={{ borderRadius: 8, color: '#fff', aspectRatio: '1 / 1', pointerEvents: ineligible ? 'none' : undefined }}
                      aria-label={t(bonus.en_title, bonus.bm_title)}
                    >
                      {/* Background image fills the card */}
                      <img
                        src={gameBannerGif}
                        alt=""
                        aria-hidden="true"
                        className="absolute inset-0 w-full h-full object-contain object-center"
                      />

                      {/* Dark gradient overlay for readability */}
                      <div
                        className="absolute inset-0"
                        style={{ background: 'linear-gradient(180deg, rgba(0,0,0,0.25) 0%, rgba(0,0,0,0.55) 55%, rgba(0,0,0,0.85) 100%)' }}
                      />

                      {/* Ineligible overlay */}
                      {ineligible && (
                        <div className="absolute inset-0" style={{ background: 'rgba(0,0,0,0.9)', zIndex: 1 }} />
                      )}

                      {/* Card content */}
                      <div className="absolute inset-0 flex flex-col items-center justify-start text-center" style={{ zIndex: 2, padding: '10px 8px', marginTop: 23 }}>
                        {/* Bonus name */}
                        <p
                          className="font-bold leading-snug whitespace-pre-line"
                          style={{ fontSize: 'clamp(10px, 2.4vw, 8px)', marginBottom: 2, textShadow: '0 1px 4px rgba(0,0,0,0.8)' }}
                        >
                          {t(bonus.en_label, bonus.bm_label)}
                        </p>

                        {/* Amount */}
                        <p
                          className="font-black leading-tight"
                          style={{
                            fontSize: 'clamp(15px, 5vw, 10px)',
                            textShadow: '0 2px 8px rgba(0,0,0,0.8)',
                          }}
                        >
                          {bonus.highlight}
                        </p>
                      </div>
                    </RegisterLink>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* SEO Blog */}
        <section
          className="py-12 md:py-16 border-y border-[#d4a017]/10"
          style={{ background: 'linear-gradient(180deg, #0d0101 0%, #120202 100%)' }}
        >
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <div className="inline-flex items-center gap-2 bg-[#cc1100]/15 border border-[#cc1100]/30 rounded-full px-4 py-1.5 mb-4">
                <i className="ri-article-line text-[#d4a017] text-xs" />
                <span className="text-[#d4a017] text-xs font-semibold tracking-widest uppercase">
                  {t('Bonus Guide', 'Panduan Bonus')}
                </span>
              </div>
              <h2 className="text-2xl md:text-3xl font-black text-white mb-3">
                {t('Complete MrCuci Bonus Guide 2026', 'Panduan Bonus MrCuci Lengkap 2026')}
              </h2>
              <p className="text-gray-400 text-sm max-w-2xl mx-auto leading-relaxed">
                <LinkedText>{t(
                  'Everything Malaysian players need to know about claiming, maximising, and understanding every MrCuci promotion.',
                  'Semua yang pemain Malaysia perlu tahu tentang menuntut, memaksimumkan, dan memahami setiap promosi MrCuci.'
                )}</LinkedText>
              </p>
            </div>

            <div className="space-y-6 md:space-y-8">
              {seoSections.map((section, idx) => (
                <article
                  key={section.id}
                  id={section.id}
                  className="rounded-2xl p-6 md:p-8 border border-[#d4a017]/10 hover:border-[#d4a017]/25 transition-all duration-300"
                  style={{ background: 'linear-gradient(135deg, #180303, #1e0404)' }}
                >
                  <div className="flex items-start gap-4 mb-4">
                    <div
                      className="w-8 h-8 flex items-center justify-center rounded-lg shrink-0 text-sm font-black text-black mt-0.5"
                      style={{ background: 'linear-gradient(135deg, #cc1100, #d4a017)' }}
                    >
                      {idx + 1}
                    </div>
                    <h3 className="text-base md:text-lg font-black text-white leading-snug">
                      {t(section.en_title, section.bm_title)}
                    </h3>
                  </div>
                  <div className="h-px mb-5 bg-gradient-to-r from-[#cc1100]/30 via-[#d4a017]/20 to-transparent" />
                  <div className="space-y-4">
                    {section.paragraphs.map((para, pIdx) => (
                      <p key={pIdx} className="text-gray-400 text-sm leading-[1.85] text-justify">
                        <LinkedText>{t(para.en, para.bm)}</LinkedText>
                      </p>
                    ))}
                  </div>
                  <div className="mt-5 pt-4 border-t border-white/5 flex items-center justify-between">
                    <span className="text-gray-600 text-xs flex items-center gap-1.5">
                      <i className="ri-time-line text-[#d4a017] text-xs" />
                      {section.paragraphs.length * 2} {t('min read', 'minit baca')}
                    </span>
                    <RegisterLink
                      source={`bonus_page_seo_claim_${section.id}`}
                      label={t('Claim Bonus', 'Tuntut Bonus')}
                      target="_blank"
                      rel="noopener noreferrer nofollow"
                      className="flex items-center gap-1 text-[#d4a017] text-xs font-semibold hover:underline"
                    >
                      {t('Claim Bonus', 'Tuntut Bonus')}
                      <i className="ri-arrow-right-s-line" />
                    </RegisterLink>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

      </main>

      <Footer />
    </div>
  );
}
